import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/fetch-duck";
import { CompanyDock } from "interfaces/company-dock";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "FETCH_DOCK_" }
);

export interface FetchDockState extends IState {
  data: CompanyDock | null;
}
export interface FetchDockSuccess extends ISuccessAction {
  data: CompanyDock;
}

const INITIAL_STATE: FetchDockState = {
  data: null,
  loading: false,
  error: null,
};

const request = (state: FetchDockState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: FetchDockState, action: FetchDockSuccess) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: FetchDockState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const fetchDock = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FetchDockTypes = Types;
export const FetchDockActions = Creators;
